var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingThreePoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 63,
    viewBox: "16 8 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9562_74167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8563 22.8073C28.586 26.88 24.8615 31.4757 21.7724 36.4839C21.6772 36.6419 21.8967 36.7909 22.0298 36.6739C26.1563 32.9741 31.0455 30.1973 36.367 28.531C41.8212 26.9521 36.9824 18.7605 32.8563 22.8073Z",
    fill: "#147AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.365 35.3222C37.5064 36.0283 31.7718 37.4801 26.2994 39.6425C26.1286 39.7121 26.2152 39.9629 26.3918 39.9488C31.9121 39.4554 37.4907 40.1579 42.7509 42.0087C48.065 44.0089 49.0927 34.5506 43.365 35.3222Z",
    fill: "#147AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7864 15.4731C16.4075 21.7 16.8276 27.9395 18.0366 34.0416C18.0765 34.2324 18.3538 34.19 18.3727 34.0036C18.9085 28.1691 20.6991 22.501 23.6233 17.3823C26.7132 12.2359 17.0723 9.36997 16.7864 15.4731Z",
    fill: "#147AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9562_74167",
    x: 0.651367,
    y: 0.0264893,
    width: 62.5703,
    height: 62.2606,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0784314 0 0 0 0 0.478431 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9562_74167"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9562_74167",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingThreePoints);
export default __webpack_public_path__ + "static/media/LandingThreePoints.c12b36570bded84d4734b7197b5ad42a.svg";
export { ForwardRef as ReactComponent };